import {
    HTTP,
} from '@/utils/http-common'

export default {
    get() {
        return new Promise((resolve, reject) => {
            return HTTP.get('/library/').then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
}